import React from "react";
import moment from "moment";
import FileSaver from "file-saver";
const AmendmentGridRow = ({ data, sno }: { data: any; sno: number }) => {
  
  return (
    <tr>
      <td>{data?.changedField || ""}</td>
      <td>{moment(data?.changedDate).format("DD/MM/yyyy HH:mm:ss")}</td>
      <td>{data?.oldValue || ""}</td>
      <td>{data?.newValue || ""}</td>
      
    </tr>
  );
};

export default AmendmentGridRow;
